// src/components/canvaspuzzle/components/pieces/HighlightedPieces.js
import React from 'react';
import useStore from '../../../../store';
import { getUserColor } from '../../utils/theme/userColor';
import PuzzlePiece from './PuzzlePiece';
import './HighlightedPieces.css'; // Оставляем для стилей имени
import { getFunnyNickname } from '../../../../utils/formatter';

const HighlightedPieces = () => {
  useStore(state => state.puzzleRender);
  const { ref } = useStore.getState();
  const { puzzle, info } = ref;
  const { state, boardCanvas, boardTransform, } = puzzle;
  const { pieces, imageDimensions, boardDimensions, config, imageScale } = state; // Добавил config
  const users = info.game?.users || {};
  const funnyNicknames = window.t('funny_nicknames', { returnObjects: true });
  const canvasRect = boardCanvas.rect;

  if (!pieces || !imageDimensions?.width || !boardDimensions?.width || !config) { // Добавил проверку config и canvasRect
    return null;
  }
  

  const now = Date.now();
  
  // Находим все подсвеченные кусочки
  const highlightedPieces = Object.keys(pieces)
    .filter(id => {
      const piece = pieces[id];
      return piece?.placed && piece.highlighted && piece.highlighted > now;
    })
    // Сортируем по времени подсветки (по убыванию: более новые кусочки вначале)
    .sort((aId, bId) => pieces[bId].highlighted - pieces[aId].highlighted)
    // Ограничиваем количество до 10 последних
    .slice(0, 50)
    .map(id => pieces[id]);

  if (highlightedPieces.length === 0) {
    return null;
  }

  return (
    <>
      {highlightedPieces.map(piece => {
        const pieceId = piece.id;
        if (!piece?.currentPos || !piece.baseDimensions) return null;

        const { scaledDimensions, scaledTotalDimensions, scaledTabExtensions, trayPosition } = puzzle.methods.calculateOnePiece(pieceId);

        // --- Корректировка позиции относительно Viewport ---
        // Координаты верхнего левого угла БАЗОВОГО прямоугольника относительно КАНВАСА
        const canvasPosX = piece.currentPos.x * boardTransform.scale;
        const canvasPosY = piece.currentPos.y * boardTransform.scale;

        // Финальные координаты относительно ОКНА БРАУЗЕРА (viewport)
        // Складываем координаты канваса относительно viewport (canvasRect.left/top)
        // и координаты пазла относительно канваса (finalPosX_canvas/finalPosY_canvas)
        const finalPosX_page = canvasRect.left + canvasPosX - scaledTabExtensions.width;
        const finalPosY_page = canvasRect.top + canvasPosY - scaledTabExtensions.height;
        // -----------------------------------------------------

        // Имя пользователя и цвет
        let placedByName = '';
        let userColor = '';
        const placedByUser = piece.placedBy ? users[piece.placedBy] : null;
        if (piece.placedBy) {
          userColor = getUserColor(piece.placedBy);
          if (placedByUser) {
            placedByName = placedByUser.first_name || getFunnyNickname(piece.placedBy, funnyNicknames);
            if (placedByName.length > 10) {
              placedByName = placedByName.substring(0, 10) + '...';
            }
          }
        }

        const glowColor = userColor || 'rgba(90, 220, 80, 0.9)';
        
        // Расчет прозрачности на основе оставшегося времени
        const remainingTime = piece.highlighted - now;
        const fadeOutStartTime = 1000; // 1 секунда до исчезновения
        const opacity = remainingTime <= fadeOutStartTime ? 0 : 1;

        const containerStyle = {
          position: 'fixed',
          left: `${finalPosX_page}px`, // Используем координаты относительно страницы/viewport
          top: `${finalPosY_page}px`,  // Используем координаты относительно страницы/viewport
          zIndex: 500,
          filter: `drop-shadow(0 0 2px ${glowColor}) drop-shadow(0 0 1px ${glowColor})`,
          pointerEvents: 'none',
          transition: 'filter 0.5s ease-out, opacity 0.5s ease-out',
          opacity: opacity,
        };

        const nameStyle = {
          position: 'absolute',
          top: '-0px', // Оставляем позиционирование имени относительно контейнера
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: `${userColor || '#555555'}99`,
          boxShadow: `0 0 5px ${userColor || '#555555'}80`,
          color: '#ffffff',
          textShadow: `0 0 3px ${userColor || '#000000'}CC`,
          padding: '0px 4px 1px 4px',
          borderRadius: '8px',
          fontSize: '11px',
          fontWeight: 'bold',
          whiteSpace: 'nowrap',
          animation: 'nameAppearAndFade 2s ease-in-out forwards',
          opacity: 0,
          zIndex: 501,
        };

        return (
          <div key={pieceId} style={containerStyle}>
            <PuzzlePiece pieceId={pieceId} />
            {placedByName && (
              <div className="puzzle-piece-name" style={nameStyle}>
                {placedByName}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default HighlightedPieces;

